import React from 'react';
import { faLaptop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function LaptopSolidIcon(props) {
  return <FontAwesomeIcon icon={faLaptop} {...props} />;
}
